import { Link } from "react-router-dom";
import ChannelCard from "@/components/base/ChannelCard";
import { channels } from "@/mocks/gossip";

export default function ChannelDirectory() {
  return (
    <section id="channels" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 md:mb-12">
          <div>
            <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-600 font-medium">
              <i className="ri-layout-grid-line" />
              频道入口大全
            </span>
            <h2 className="mt-2.5 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              按板块找到想看的瓜点
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
              每个入口都标注了内容方向、类型与最近更新时间，频道看广度、版块看热度、栏目看深度，挑一个直接进去翻。
            </p>
          </div>
          <Link
            to="/channels"
            className="shrink-0 inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium whitespace-nowrap bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors cursor-pointer"
          >
            查看全部入口
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {channels.map((channel) => (
            <ChannelCard key={channel.slug} channel={channel} />
          ))}
        </div>
      </div>
    </section>
  );
}